import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CInfo',
  props: {
    variant: { default: 'default' },
    icon: null,
    text: null
  },
  setup(__props: any) {

const props = __props as { variant: 'default' | 'danger' | 'neutral', icon?: string | string[], text?: string };



const slots = useSlots();

const computedClass = computed(() => {
    const variants: Record<string, string> = {
        default: 'bg-purple-lightest border-purple',
        danger: 'bg-danger-lightest border-danger',
        neutral: 'bg-gray-lightest border-gray-light'
    };
    return variants[props.variant];
});

return { __sfc: true,props, slots, computedClass }
}

})